<template>
    <div>
        <div class="row">
            <div class="col-lg-6 offset-lg-3 col-12 text-center p-0">
                <div class="card shadow-sm">
                    <div class="card-header">
                        <p class="text-center" style="margin: 0px;">ผู้กู้สินเชื่อ</p>
                    </div>
                    <div class="card-body">
                        <p class="h6">กรุณายืนยันตัวตนผู้กู้และผู้คำประกัน เพื่อทำการยื่นขอสินเชื่อเงินสดผ่าน App</p>
                    </div>
                    <div class="card-body">
                        <img :src="mergeUrl" alt="" class="img-fluid pa-2" >
                    </div>
                    <div class="row my-1">
                        <label class="control-label col-sm-12 h5">ลายเซ็นต์ยืนยันตัวตน</label>
                        <div class="col-sm-12" style="text-align: center;">
                            <canvas class="canvas-box land-signature-pad" ref="signaturePadBorrower"></canvas>
                        </div>
                        <div class="col-sm-12 my-2" style="text-align: center;">
                          <button class="btn btn-outline-info btn-lg btn-block" @click="clearSignature()"><i class="fas fa-undo"></i> เขียนลายเซ็นต์ใหม่</button>
                          <button class="btn btn-outline-success btn-lg btn-block" @click="useSignature()"><i class="fas fa-check"></i> ยืนยันลายเซ็นต์่</button>
                        </div>
                    </div>
                   
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import SignaturePad from 'signature_pad'
export default {
  computed: {
    ...mapGetters({
      nimcapDetils: 'nimcap/GET_DETAILS'
    }),
    mergeUrl: {
      get () {
        return this.nimcapDetils.mergeUrl
      }
    }
  },
  methods: {
    ...mapActions({
      SET_EL_VALUE: 'nimcap/SET_EL_VALUE'
    }),
    nextPage () {
      this.$emit('next')
    },
    clearSignature () {
      this.signatureBorrower.clear()
      let payload = {
        main_key: 'borrowerImage',
        sub_key: 'signature',
        value: null
      }
      this.SET_EL_VALUE(payload)
    },
    useSignature () {
      let payload = {
        main_key: 'borrowerImage',
        sub_key: 'signature',
        value: this.signatureBorrower.toDataURL()
      }
      this.SET_EL_VALUE(payload)
    }
  },
  mounted () {
    let canvas = this.$refs.signaturePadBorrower
    this.signatureBorrower = new SignaturePad(canvas, {
      backgroundColor: 'rgb(255, 255, 255)'
    })
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext('2d').scale(ratio, ratio)
  }
}
</script>

<style scoped>
.land-signature-pad {
  border: 1px solid salmon;
  border-radius: 25px;
  max-width: 400px;
}

.canvas-box {
  border-radius: 25px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 120px;
}
.font-size-li{
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/nimcap/Components/Borrower/Step6.vue